const BC = { fontFamily: "'Oswald', sans-serif" } as const;

const NAV_LINKS = [
  { label: "Tracks", href: "/tracks" },
  { label: "Events", href: "/events" },
  { label: "Clubs",  href: "/clubs"  },
] as const;

export default function SiteNav() {
  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 md:px-10 py-4 border-b border-[#242424]"
      style={{ background: "rgba(11,11,11,0.88)", backdropFilter: "blur(14px)" }}
    >
      {/* Logo */}
      <a href="/" className="no-underline" style={BC}>
        <span className="text-2xl font-black tracking-widest uppercase text-[#f0ece8]" style={BC}>
          Drift<span className="text-[#ff2e89]" style={BC}>ables</span>
        </span>
      </a>

      {/* Links — hidden on mobile */}
      <ul className="hidden md:flex gap-9 list-none m-0 p-0">
        {NAV_LINKS.map(({ label, href }) => (
          <li key={label}>
            <a
              href={href}
              className="no-underline uppercase text-sm font-semibold tracking-widest text-[#777] hover:text-[#f0ece8] transition-colors"
              style={BC}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
      <div className="flex gap-2">

      {/* CTA */}
      {/* One door: signing in and signing up are the same email link. */}
      <a
        href="/users/sign_in"
        className="no-underline uppercase text-sm font-bold tracking-widest bg-[#ff2e89] text-[#0b0b0b] px-5 py-2 hover:opacity-80 transition-opacity"
        style={BC}
      >
        Sign In
      </a>
      </div>
    </nav>
  );
}
